import React from 'react';

const JSON_Syntax = () => {
  return (
    <div >
      <h1>JSON_Syntax</h1>
      <p>Placeholder component for: "JSON Syntax"</p>
    </div>
  );
};

export default JSON_Syntax;
